import React, { Component } from 'react';
import KeeVue from '../base/KeeVue.js'
import {Pagination} from '@jd/find-react';
import { Document, Page, pdfjs  } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default class FsPdf extends KeeVue {
  constructor(props){
    super(props);
    this.state = {
    page:1,
    totalPage:0
    };
  };

 componentDidMount() {
 	this.registComponent();

 }


 componentWillReceiveProps(nextProps){
 console.log("更新了",this.state)
  //this.refresh();
  }


  onChange = (pages) => {
         console.log(pages);
         this.setState({
           page: pages,
         });

}
  onDocumentLoadSuccess = (page) => {
        console.log("total",page._pdfInfo.numPages)
        this.setState({totalPage:page._pdfInfo.numPages})
        console.log(this.state)

}


  render() {
  console.log(this.props.component.cp.fileUrl)
    return (
     <div>

                 <Document
                     file={this.props.component.cp.fileUrl}
                     onLoadSuccess={this.onDocumentLoadSuccess}
                     loading="正在努力加载中" //加载时提示语句
                     renderMode="canvas"	 //定义文档呈现的形式
                     externalLinkTarget="_blank"
                 >
                     <Page pageNumber={this.state.page} scale={2}/>
                 </Document>
                <Pagination current={this.state.page} onChange={this.onChange} total={this.state.totalPage*10}></Pagination>
             </div>
    )
  }
}